import Model  from 'alto-orm/lib/orm/model'

export default class Setting extends Model
  constructor: (key, value, id) ->
    super()

    @key   = key
    @value = value
    @id    = id
